import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, Typography, IconButton } from '@totalsoft/rocket-ui';
import Details from '@mui/icons-material/PlaylistAdd';
import ScoringCategoryDetailListComponent from './ScoringCategoryDetailListComponent';
import { getErrors } from '@totalsoft/pure-validations-react';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';

const ScoringCategoryDetailListCard = ({
  scoringCategoryDetails,
  dispatch,
  scaleFormat,
  onSave,
  onDelete,
  visibleNumeric,
  validation,
  minMaxInvalid
}) => {
  const { t } = useTranslation();

  const onAddDetail = () => {
    dispatch({
      type: 'OnDetailAdd'
    });
  };

  return (
    <Card
      icon={Details}
      iconColor='primary'
      title={t('ScoringCategories.Details.Title')}
      subheader={
        <Typography color='error'>
          {validation |> getErrors}{"\n"}
          {minMaxInvalid ? '' : t('ScoringCategories.Details.Validators.MinMaxValueWrong')}
        </Typography>
      }
      actions={
        <IconButton
          type='add'
          fontSize='medium'
          color='transparent'
          tooltip={t('Tooltips.ScoringCategories.AddDetail')}
          onClick={onAddDetail}
        />
      }
    >
      <CardNoResultsWrapper content={scoringCategoryDetails}>
        <ScoringCategoryDetailListComponent
          scoringCategoryDetails={scoringCategoryDetails}
          scaleFormat={scaleFormat}
          dispatch={dispatch}
          onSave={onSave}
          onDelete={onDelete}
          visibleNumeric={visibleNumeric}
          validation={validation}
        />
      </CardNoResultsWrapper>
    </Card>
  );
};

ScoringCategoryDetailListCard.propTypes = {
  dispatch: PropTypes.func.isRequired,
  scoringCategoryDetails: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  visibleNumeric: PropTypes.number,
  scaleFormat: PropTypes.number.isRequired,
  validation: PropTypes.object,
  minMaxInvalid: PropTypes.bool.isRequired
};

export default ScoringCategoryDetailListCard;
